// PreviewAddressModal.jsx
import { Modal, Button } from 'react-bootstrap';

export default function PreviewAddressModal({
    type = '',
    show,
    title,
    addresses,
    onHide,
    onSelect,
    onAddNew,
    onDelete,
    context,
    dialogClassName,
    size = 'md',
}) {
    return (
        <Modal
            size={size}
            dialogClassName={dialogClassName}
            aria-labelledby="address-modal-title"
            centered
            show={show}
            onHide={onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title id="address-modal-title" className="modal-title-strong text-center">
                    {title}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 auto-rows-fr items-stretch">
                    {addresses?.map((addr, index) => (
                        <div key={addr.id ?? index} className="h-full">
                            <AddressCard
                                address={addr}
                                onSelect={() => onSelect(addr)}
                                onDelete={onDelete ? () => onDelete(addr) : undefined}
                                context={context}
                            />
                        </div>
                    ))}
                </div>

                <div
                    role="button"
                    className="mt-4 inline-flex border rounded text-sm px-3 py-2 cursor-pointer select-none hover:bg-gray-50"
                    onClick={onAddNew}
                >
                    + Add new {type} address
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={onHide} className="req-quote-btn cursor-pointer">
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}


function AddressCard({ address, onSelect, onDelete, context }) {
    const {
        firstName,
        lastName,
        addressLineOne,
        addressLineTwo,
        city,
        state,
        country,
        postalCode,
        phoneNo,
        dialCode,
    } = address ?? {};

    const phone = phoneNo ? `Mobile: ${dialCode ? `+${dialCode}-` : ''}${phoneNo}` : '';

    return (
        <div className="h-full flex flex-col rounded-lg border border-gray-200 bg-white shadow-sm hover:shadow-md transition-shadow">
            <div className="p-4 grow">
                <div className="text-gray-900 font-medium text-base leading-6 truncate">
                    {firstName} {lastName || ''}
                </div>

                <div className="mt-1 text-sm text-gray-700 space-y-0.5">
                    <div className="break-words">{addressLineOne}</div>
                    {addressLineTwo ? <div className="text-gray-600 break-words">{addressLineTwo}</div> : null}
                    <div className="text-gray-600">{city} {state}</div>
                    <div className="text-gray-600">{country} {postalCode}</div>
                    {phone && <div className="text-gray-600">{phone}</div>}
                </div>
            </div>

            <div className="p-4 pt-0 flex items-center gap-2">
                <button
                    type="button"
                    onClick={onSelect}
                    className="inline-flex items-center justify-center rounded-md bg-primaryColor px-3 py-1.5 text-sm font-medium text-white shadow-sm hover:brightness-95 focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-pointer"
                >
                    Select
                </button>

                {onDelete && (
                    <button
                        type="button"
                        title={`Delete address (${context ?? 'General'})`}
                        onClick={onDelete}
                        className="inline-flex items-center justify-center rounded-md bg-red-50 text-red-700 px-3 py-1.5 text-sm font-medium border border-red-200 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 active:bg-red-200 cursor-pointer"
                    >
                        Delete
                    </button>
                )}
            </div>
        </div>
    );
}

